const MODIFICATION_REASONS = Object.freeze([
    { value: "NOT_SELF_ID_CARD", label: "非本人身份证" },
    { value: "NAME_CHANGE", label: "姓名变更" },
    { value: "ID_CARD_CORRECTION_OR_CHANGE", label: "身份证号码更正或变更" },
    { value: "OTHER", label: "其他" },
]);

const MODIFICATION_STATUS = Object.freeze({
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    WITHDRAWN: "WITHDRAWN",
});

const STATUS_BY_CODE = Object.freeze({
    1: MODIFICATION_STATUS.PENDING,
    2: MODIFICATION_STATUS.APPROVED,
    3: MODIFICATION_STATUS.REJECTED,
    4: MODIFICATION_STATUS.WITHDRAWN,
});

const STATUS_LABELS = Object.freeze({
    [MODIFICATION_STATUS.PENDING]: "待处理",
    [MODIFICATION_STATUS.APPROVED]: "已通过",
    [MODIFICATION_STATUS.REJECTED]: "已驳回",
    [MODIFICATION_STATUS.WITHDRAWN]: "已撤回",
});

const asText = (value) => typeof value === "string" ? value.trim() : "";

const findReason = (value) => MODIFICATION_REASONS.find((item) => item.value === value);

const normalizeModificationApplication = (data = {}) => {
    const status = STATUS_BY_CODE[Number(data.status)] || MODIFICATION_STATUS.PENDING;
    const reason = asText(data.reason);
    const reasonItem = findReason(reason);

    return {
        id: Number(data.id) || null,
        reason,
        reasonLabel: reasonItem ? reasonItem.label : "其他",
        description: asText(data.description),
        status,
        statusLabel: STATUS_LABELS[status],
        resolutionReason: asText(data.resolutionReason),
        submittedAt: asText(data.submittedAt),
        finishedAt: asText(data.finishedAt),
    };
};

const normalizeModificationApplications = (data) => Array.isArray(data)
    ? data.map(normalizeModificationApplication)
    : [];

const hasApprovedModificationApplication = (applications) => Array.isArray(applications) &&
    applications.some((application) => application && application.status === MODIFICATION_STATUS.APPROVED);

const containsSensitiveContent = (description) => {
    const text = asText(description);
    return /\d{17}[\dXx]/.test(text) ||
        /data:image\/[a-z0-9.+-]+;base64,/i.test(text) ||
        /\bbase64\b/i.test(text) ||
        /https?:\/\/\S+/i.test(text);
};

const isIdentityConflict = (error) => {
    const status = error && error.response && error.response.status;
    const code = error && error.code;
    const message = asText(error && error.message);
    return (status === 409 || Number(code) === 409) && /已被其他账号绑定/.test(message);
};

const validateModificationApplication = ({ reason, description } = {}) => {
    if (!findReason(reason)) return "请选择修改实名认证原因";
    const normalizedDescription = asText(description);
    if (!normalizedDescription) return "请填写申请说明";
    if (normalizedDescription.length > 200) return "申请说明不能超过 200 个字符";
    if (containsSensitiveContent(normalizedDescription)) return "申请说明不能包含身份证号、证件图片或 Base64 等敏感内容";
    if (!/[\u4E00-\u9FFF]/.test(normalizedDescription)) return "申请说明请使用中文填写";
    return "";
};

module.exports = {
    MODIFICATION_REASONS,
    MODIFICATION_STATUS,
    normalizeModificationApplication,
    normalizeModificationApplications,
    hasApprovedModificationApplication,
    isIdentityConflict,
    validateModificationApplication,
};
